import styles from "../landing-page-mobile-one.module.css";

export const ShippingSectionMobile = () => {
  return (
    <section className={styles.shippingSection}>
      <h2 className={styles.shippingTitle}>FREE UK SHIPPING</h2>
      <p className={styles.shippingSubtitle}>
        From £34.99 with <strong>delivery included</strong> within the UK.
      </p>
    </section>
  );
};
